
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/custom",
      function () {
        return require("private-next-pages/destinations/custom.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/custom"])
      });
    }
  